import { render } from "./PDetails.vue?vue&type=template&id=ded05902&scoped=true"
import script from "./PDetails.vue?vue&type=script&lang=js"
export * from "./PDetails.vue?vue&type=script&lang=js"

import "./PDetails.vue?vue&type=style&index=0&id=ded05902&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ded05902"]])

export default __exports__